import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'common-action',
  components: {
  }
})
export default class CommonActionComponent extends Vue {
 

  @Prop()
    element!: any;

  @Prop()
    selectWidget!:any;

  @Prop()
    index!:number;

  mounted() {
      
  }

  handleWidgetDelete(index : number){
    this.$emit('handleWidgetDelete', index);
  }

  setRequired(element : any, index : number){
    this.$emit('setRequired', {element,index});
  }
  
}